import React from 'react';
import numeral from 'numeral';
import { Tooltip, Input } from '@capcenter/shared-legacy';
import { Icon } from '@capcenter/shared-legacy';

export default class PurchasePrice extends React.Component<{
  active: string;
  CountyId: string;
  onChange: Function;
  label: string;
  inputKey: string;
  disabled: Boolean;
  invalid: Boolean;
  availability: any;
}> {
  readonly state = {
    lowestPurchase: 0,
    invalidValue: '',
    loading: false,
  };

  convertDollar = (value: string) => Number(value.replace(/[^0-9-]+/g, ''));

  onChange = (value: number) => {
    if (this.props?.availability?.LoanAmountLimits && value < this.props.availability.LoanAmountLimits.LowBalanceLowerLimit) {
      this.setState({ invalidValue: value.toString(), lowestPurchase: this.props.availability.LoanAmountLimits.LowBalanceLowerLimit });
      this.props.onChange(true, { inputKey: 'isInvalidPurchasePrice' });
    } else {
      this.setState({ invalidValue: '' }, this.props.onChange(value.toString(), this.props));
      this.props.onChange(false, { inputKey: 'isInvalidPurchasePrice' });
    }
  };

  render() {
    return (
      <>
        <Input
          id='quote--PurchasePrice'
          label={this.props.label}
          invalid={(this.props.invalid || this.state.invalidValue !== '') && !this.props.disabled}
          invalidCheck={true}
          disabled={this.props.disabled}
          value={
            this.state.invalidValue !== ''
              ? this.state.invalidValue
              : this.props.active === ''
                ? ''
                : parseInt(this.props.active)
          }
          mask="dollar"
          maxLength={12}
          onChange={(e: any) => this.onChange(this.convertDollar(e.target.value))}
        />
        <div style={{marginTop: '-5px', marginBottom: '5px'}}>
          <span className='text-danger'>
            {this.state.invalidValue !== '' ? 
              <>
                <Icon icon="exclamation-triangle" /> Amount must be higher than $ {numeral(this.state.lowestPurchase).format('0,0')}
              </>
              :
              <></>
            }
          </span>
        </div>
      </>
    );
  }
}
